module.exports = __webpack_public_path__ + "img/planet-intro-sdg.7ef4596b.svg";